/**
 * Query builders + keys de MEDIA (F3-F), local-first sobre PowerSync (Drizzle).
 * `video_asset` se sincroniza en los streams de curso (sin storage_key);
 * `video_watch_progress` en `my_learning`. Lectura offline; la reproducción se
 * firma aparte por REST.
 */

import {
  and,
  asc,
  eq,
  isNull,
  type PowerSyncDrizzleDB,
  video_asset,
  video_watch_progress,
} from "@space/powersync";
import { watchProgressId } from "./watch-progress";

export const mediaQueryKeys = {
  all: ["media"] as const,
  asset: (videoId: string | undefined) => ["media", "asset", videoId] as const,
  byCourse: (courseId: string | undefined) => ["media", "course", courseId] as const,
  watch: (videoId: string | undefined, userId: string | undefined) =>
    ["media", "watch", userId, videoId] as const,
  watchAll: (userId: string | undefined) => ["media", "watch-all", userId] as const,
};

/** Un `video_asset` por id (vista de cliente, sin columnas server-only). */
export function getVideoAssetQuery(db: PowerSyncDrizzleDB, videoId: string) {
  return db
    .select()
    .from(video_asset)
    .where(and(eq(video_asset.id, videoId), isNull(video_asset.deleted_at)))
    .limit(1);
}

/** Vídeos activos de un curso (biblioteca del autor / picker). */
export function getCourseVideosQuery(db: PowerSyncDrizzleDB, courseId: string) {
  return db
    .select()
    .from(video_asset)
    .where(and(eq(video_asset.course_id, courseId), isNull(video_asset.deleted_at)))
    .orderBy(asc(video_asset.created_at));
}

/** Progreso de visionado del usuario para un vídeo (id determinista). */
export function getWatchProgressQuery(db: PowerSyncDrizzleDB, userId: string, videoId: string) {
  return db
    .select()
    .from(video_watch_progress)
    .where(eq(video_watch_progress.id, watchProgressId(userId, videoId)))
    .limit(1);
}

/** Todo el progreso de visionado del usuario (para badges "continuar en…"). */
export function getAllWatchProgressQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db.select().from(video_watch_progress).where(eq(video_watch_progress.user_id, userId));
}
